import axios from 'axios';

const STORAGE_BASE =
  process.env.REACT_APP_STORAGE_BASE ||
  process.env.REACT_APP_STORAGE_URL ||
  process.env.REACT_APP_API_BASE ||
  'http://localhost:3000';

export interface UploadResult {
  key: string;
  url: string;
  size: number;
}

export const uploadVideoFile = async (file: File): Promise<UploadResult> => {
  const key = `ads/videos/${Date.now()}-${file.name}`;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('key', key);

  const response = await axios.post(`${STORAGE_BASE}/storage/upload`, formData, {
    // Let the browser set the correct multipart boundary header
    headers: {
      Accept: 'application/json',
    },
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  });

  const data = response.data as { ok?: boolean; key?: string; size?: number };
  if (!data || data.ok === false || !data.key) {
    throw new Error('Upload failed');
  }

  const downloadUrl = `${STORAGE_BASE}/storage/download/${encodeURIComponent(data.key)}`;
  return {
    key: data.key,
    url: downloadUrl,
    size: typeof data.size === 'number' ? data.size : file.size,
  };
};
